import { useTranslation } from 'react-i18next';
import { StandardBreadcrumbs } from 'src/components/Breadcrumbs/StandardBreadcrumbs';
import { BackButton } from 'src/components/Button';
import { AccountDetailsProps } from '../AccountDetailsPage';
import ChangeYourPassword from './ChangeYourPassword/ChangeYourPassword';
import MyProfile from './MyProfile/MyProfile';
import { BreadCrumbsMargin, ContentContainer, InnerContentContainer } from './styles';

export default function DesktopAccountDetails({
  oldPassword,
  setOldPassword,
  newPassword,
  setNewPassword,
  verifyNewPassword,
  setVerifyNewPassword,
  submit,
  checkPasswordsMatch,
  error,
  userDetailsFormState,
  handleMyProfileFormChange,
  submitMyProfileForm,
  userEmail,
  isApplyUserLoading,
  onClickBackButton,
}: AccountDetailsProps) {
  const { t } = useTranslation('accountDetails');

  return (
    <ContentContainer>
      <BackButton onClick={onClickBackButton} />
      <BreadCrumbsMargin>
        <StandardBreadcrumbs
          current={{ name: t('title') }}
          parents={[{ name: t('prevBreadcrumb'), url: '/my-account' }]}
        />
        <InnerContentContainer>
          <MyProfile
            userDetailsFormState={userDetailsFormState}
            handleMyProfileFormChange={handleMyProfileFormChange}
            submitMyProfileForm={submitMyProfileForm}
            userEmail={userEmail}
            isApplyUserLoading={isApplyUserLoading}
          />
          <ChangeYourPassword
            oldPassword={oldPassword}
            setOldPassword={setOldPassword}
            newPassword={newPassword}
            setNewPassword={setNewPassword}
            verifyNewPassword={verifyNewPassword}
            setVerifyNewPassword={setVerifyNewPassword}
            submit={submit}
            checkPasswordsMatch={checkPasswordsMatch}
            error={error}
          />
        </InnerContentContainer>
      </BreadCrumbsMargin>
    </ContentContainer>
  );
}
